module.exports = __webpack_public_path__ + "static/media/us.8ec58318.svg";